import i18n from "i18next"
import LanguageDetector from "i18next-browser-languagedetector"
import isEmpty from "lodash-es/isEmpty"
import keys from "lodash-es/keys"
import { initReactI18next } from "react-i18next"

import { FALLBACK_LANG } from "$/constants"

import translationEN from "./locales/en/translation.json"
import translationES from "./locales/es/translation.json"
import translationsPT from "./locales/pt/translation.json"

type TTranslationKeys = typeof translationEN | typeof translationsPT | typeof translationES

type TTFunction = (key: keyof TTranslationKeys, opts?: Record<string, number | string>) => string

if (!i18n.isInitialized) {
    void i18n
        .use(LanguageDetector)
        .use(initReactI18next)
        .init({
            detection: { order: ["querystring", "localStorage", "navigator"] },
            fallbackLng: FALLBACK_LANG,
            supportedLngs: isEmpty(JSAPP_CONF?.available_languages)
                ? ["en", "pt", "es"]
                : keys(JSAPP_CONF?.available_languages),
            returnEmptyString: false,
            resources: {
                en: { translation: translationEN },
                es: { translation: translationES },
                pt: { translation: translationsPT }
            },
            interpolation: { escapeValue: false },
            nsSeparator: false,
            keySeparator: false
        })
    i18n.isInitialized = true
}

export { i18n, type TTranslationKeys, type TTFunction }
